import * as core from '../../../../../../../core'
import * as prebuilt from '../../../../../../prebuilt'
import * as space from '../space'

export const RESOURCE = {
  payload: {
    alias: 'space:cluster',
    appAlias: space.RESOURCE.payload.alias,
    description: 'Single Cluster Details page',
    name: 'Cluster Details',
    page: { id: prebuilt.Page.Id.SpaceCluster },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
